"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3603],{

/***/ 63603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Spinner_Spinner; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(17058);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Spinner/PanIcon.tsx





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 121 162"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "121",
            height: "162",
            fill: "none",
            viewBox: "0 0 121 162",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    filter: "url(#filter0_d_1630_5670)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            strokeLinecap: "round",
                            filter: "url(#filter1_d_1630_5670)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    stroke: "url(#paint0_linear_1630_5670)",
                                    strokeWidth: "11.453",
                                    d: "M25.37 61.578c-7.36 1.61-14.106 7.91-16.763 13.962-1.95 4.44-3.422 11.496-.219 18.646"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    stroke: "#C7D2D7",
                                    strokeOpacity: "0.3",
                                    strokeWidth: "2.704",
                                    d: "M12.21 76.596c-1.32-.374-2.931-.77-5.612-3.362M14.35 72.092c-.815-.212-1.838-.426-2.724-2.225M9.969 80.305c-.766.122-1.696.31-3.417-.681"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            filter: "url(#filter2_d_1630_5670)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "url(#paint1_linear_1630_5670)",
                                    d: "M39.712 51.28c-6.518 0-12.252 4.358-13.429 10.769-2.652 14.451-4.286 33.342-.805 39.168 3.822 6.396 12.381 8.34 17.839 8.62v.014c.374.018.783.026 1.222.023.439.003.848-.005 1.222-.023v-.014c5.458-.28 14.017-2.224 17.839-8.62 3.481-5.826 1.847-24.717-.806-39.168-1.176-6.41-6.91-10.768-13.428-10.768h-9.654z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#fff",
                                    fillRule: "evenodd",
                                    d: "M40.225 96.525l.047 7.953c.032 5.472.987 18.79 2.523 25.453a7.953 7.953 0 01-15.5 3.572c-1.912-8.291-2.895-22.925-2.93-28.932l-.047-7.953 15.907-.093zM49.274 96.525l-.047 7.953c-.032 5.472-.987 18.79-2.523 25.453a7.953 7.953 0 0015.5 3.572c1.912-8.291 2.895-22.925 2.93-28.932l.047-7.953-15.907-.093z",
                                    clipRule: "evenodd"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    stroke: "#C7D2D7",
                                    strokeLinecap: "round",
                                    strokeOpacity: "0.3",
                                    strokeWidth: "2.704",
                                    d: "M28.052 103.189c5.482 4.035 19.752 9.684 32.975 0M29.041 113.408c1.82.506 3.992 1.172 9.282.746M60.46 113.408c-1.819.506-3.99 1.172-9.28.746M33.825 119.886c.909.1 1.998.249 4.492-.367M55.677 119.886c-.909.1-1.998.249-4.492-.367"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#282522",
                            fillRule: "evenodd",
                            d: "M61.12 132.286c-3.271.39-8.434.806-13.849-.602-.976-.254-1.964.482-1.923 1.49l.502 12.456c.006.155.036.307.091.449-.035 1.274-.082 4.113.002 5.62.084 1.524.242 2.434 1.336 2.963.677 2.585 3.35 4.636 9.49 4.552 6.08-.084 6.29-1.248 6.396-1.836l.003-.017v-2.699c0-1.928-1.105-4.008-2.86-5.708.333-.209.549-.57.6-.972l1.806-14.097a1.43 1.43 0 00-1.594-1.599z",
                            clipRule: "evenodd"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "url(#paint2_linear_1630_5670)",
                            d: "M50.89 153.613c3.315 1.657 10.637.69 11.518 0 .556-1.621-1.921-4.559-3.804-5.223-2.81-.99-6.72-.583-7.714.56-.373.43-3.315 3.006 0 4.663z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#282522",
                            fillRule: "evenodd",
                            d: "M27.883 132.127c3.27.39 8.434.806 13.849-.602.976-.254 1.964.482 1.923 1.49l-.502 12.456a1.385 1.385 0 01-.091.449c.035 1.274.082 4.113-.002 5.62-.084 1.524-.242 2.434-1.336 2.964-.677 2.584-3.35 4.636-9.49 4.551-6.08-.084-6.29-1.247-6.396-1.835l-.003-.017v-2.699c0-1.929 1.105-4.009 2.86-5.709a1.34 1.34 0 01-.6-.972l-1.806-14.097a1.43 1.43 0 011.594-1.599z",
                            clipRule: "evenodd"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "url(#paint3_linear_1630_5670)",
                            d: "M38.113 153.454c-3.316 1.657-10.637.691-11.518 0-.556-1.62 1.921-4.558 3.804-5.222 2.81-.991 6.72-.584 7.714.559.373.43 3.315 3.007 0 4.663z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            strokeLinecap: "round",
                            filter: "url(#filter3_d_1630_5670)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    stroke: "url(#paint4_linear_1630_5670)",
                                    strokeWidth: "11.453",
                                    d: "M96.642 58.285c-7.699 4.557-13.093 6.707-18.247 7.333-5.154.626-10.607-2.409-18.463-5.337"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    stroke: "#C7D2D7",
                                    strokeOpacity: "0.3",
                                    strokeWidth: "2.704",
                                    d: "M77.51 68.311c-.35-1.325-.83-2.914.035-6.54M83.777 65.9c-.858-.707-1.945-1.526-2.48-4.31M72.419 65.574c.075-.657.152-1.445.761-3.243"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#282522",
                            d: "M3.98 95.636c-1.588 2.166-.774 5.219 1.674 6.28l4.642 2.012c1.547.541 3.285-.959 3.875-.972 1.641 2.526 4.982 10.883 8.494 11.044 3.348.153 1.922-7.23.69-9.127-.505-.776 1.79.513 1.414-1.563-1.15-6.33-2.674-7.542-5.784-8.46a4.114 4.114 0 00-1.133-2.15l-3.296-3.303c-1.813-1.817-4.846-1.57-6.378.518L3.98 95.636zM101.196 63.355c-1.713 2.047-4.87 1.962-6.497-.176l-4.295-5.648c-1.568-2.062-.944-5.04 1.313-6.263l4.102-2.224a4.115 4.115 0 012.383-.476c.26-.673.173-.902.74-1.699.566-.796 1.991-1.413 2.424-1.566.416-.147 2.897-.341 3.253-.434l.568-.28c4.057-1.996 7.21-6.856 9.697-4.493.74 1.192-3.667 2.61-4.302 4.565 2.812 7.082.369 9.403-5.311 13.228a4.178 4.178 0 01-.829 1.587l-3.246 3.88z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            filter: "url(#filter4_d_1630_5670)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "url(#paint5_radial_1630_5670)",
                                    d: "M47.717 61.048c15.655-2.406 26.395-17.047 23.989-32.702C69.299 12.69 54.657 1.95 39.002 4.356 23.348 6.764 12.608 21.406 15.014 37.06c2.407 15.654 17.048 26.395 32.703 23.988z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "url(#paint6_linear_1630_5670)",
                                    stroke: "#AE6666",
                                    strokeOpacity: "0.5",
                                    strokeWidth: "0.477",
                                    d: "M62.41 32.989c0 3.926-1.062 6.054-4.388 7.18H28.697c-3.326-1.126-4.388-3.254-4.388-7.18 0-13.96 8.529-19.051 19.05-19.051 10.522 0 19.051 4.983 19.051 19.05z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "url(#paint7_radial_1630_5670)",
                                    d: "M60.522 24.777c-2.712-6.06-6.458-9.667-16.099-10.387 5.1 1.77 1.791 7.333 2.284 13.08.575 6.79 11.272 8.109 9.59 10.258a2.896 2.896 0 01-2.233 1.09l-26.033.125c.377.623.437.875 1.365.864h27.903c.867-.006 2.935-.56 4.246-3.239.872-1.782-.379-10.35-1.023-11.79z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    stroke: "#fff",
                                    strokeLinecap: "round",
                                    strokeWidth: "2.56",
                                    d: "M57.78 32.703c.625 2.145-1.744 5.095-4.157 5.095"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    stroke: "#fff",
                                    strokeLinecap: "round",
                                    strokeWidth: "3.243",
                                    d: "M29.57 27.053c.4-2.94 3.032-8.855 10.362-8.992"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#A176F3",
                    d: "M36.111 75.976l-.244 3.899-1.211.053.01-2.056-.546 1.657h-.468l-.42-1.481-.005 1.72-1.227.038.053-3.67 1.365-.054.542 1.758.722-1.864h1.43zM47.621 78.52c0 .2-.002.399-.007.595-.004.195-.01.392-.019.59l-1.53-.027c.053-.313.1-.626.138-.937a7.69 7.69 0 00.056-1.06 3.512 3.512 0 00-.035-.372 1.111 1.111 0 00-.04-.188.459.459 0 00-.06-.139c-.023-.037-.052-.055-.085-.055a.233.233 0 00-.154.053.44.44 0 00-.104.138.878.878 0 00-.064.186 2.145 2.145 0 00-.056.552c-.008.314-.016.625-.02.935-.006.308-.013.62-.022.935l-1.355.058c.036-.625.07-1.246.101-1.864.034-.618.06-1.24.08-1.865l1.254-.063-.011.425c.05-.06.103-.117.16-.17a1.038 1.038 0 01.392-.226.98.98 0 01.63.04.9.9 0 01.292.202c.081.085.15.186.205.302.055.115.099.239.132.37.034.13.06.268.077.411a7.82 7.82 0 01.045.82v.354zM49.446 79.317c0 .078-.015.15-.045.218a.59.59 0 01-.298.297.556.556 0 01-.73-.297.57.57 0 010-.436.572.572 0 01.515-.345.557.557 0 01.39.167.55.55 0 01.168.396zM53.26 78.919a.817.817 0 01-.298.65c-.09.075-.195.136-.314.184a2.258 2.258 0 01-.366.109 2.823 2.823 0 01-.385.053 4.582 4.582 0 01-1.052-.04 3.27 3.27 0 01-.346-.077 2.054 2.054 0 01-.32-.125l-.006-3.421c.099-.04.204-.077.316-.109.111-.034.225-.06.34-.082.117-.023.233-.04.348-.05a3.125 3.125 0 01.714.005c.13.016.254.042.372.08.119.036.23.085.332.145.103.059.192.132.268.218a.931.931 0 01.18.303 1.105 1.105 0 01.025.677.775.775 0 01-.316.412.858.858 0 01-.258.106c.115.03.22.075.314.133a.907.907 0 01.396.494.99.99 0 01.055.335zm-1.35-1.514a.25.25 0 00-.032-.13.302.302 0 00-.18-.14.337.337 0 00-.096-.017.342.342 0 00-.104.016.942.942 0 00-.098.037l-.016.59c.04 0 .091-.004.151-.011a.637.637 0 00.173-.045.388.388 0 00.143-.106.298.298 0 00.059-.194zm-.377.866c-.052 0-.101.005-.149.016l-.01.605.076.016a.572.572 0 00.324-.053.292.292 0 00.135-.26.306.306 0 00-.039-.165.304.304 0 00-.215-.146.623.623 0 00-.122-.013zM55.333 76.125l-.186 3.617-1.12.058-.107-3.601 1.413-.074zM58.586 77.054l-1.217 1.535h1.121l.037 1.126-2.369.096-.106-1.041 1.386-1.7-1.375.096-.01-1.068h2.485l.048.956z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "42.063",
                    cy: "77.865",
                    r: "1.953",
                    fill: "#fff",
                    stroke: "#A176F3",
                    strokeWidth: "0.121"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#A176F3",
                    d: "M41.016 79.478l-.022.034.046.03.015-.053-.039-.011zm0 0l.022-.034-.046-.03-.015.052.04.012zm-.041-3.192l.039-.011-.016-.054-.046.032.023.033zm0 .002l-.038.011.015.054.046-.032-.023-.033zm1.177.054l.035-.022-.005-.005-.03.027zm.009.012l-.03.026.064-.048-.034.022zm-.005-.008l.029-.028-.063.05.034-.022zm.183-.16l.025-.032-.056.056.031-.025zm.008.005l-.025.032.058-.054-.033.022zm-.037-.032l-.022.033.003.002.02-.035zm-.051 2.811h-.04v.001h.04zm-1.204.519l-.078-.023.078.023zm-.955-1.62c0 .688.356 1.294.894 1.643l.044-.068a1.875 1.875 0 01-.857-1.576h-.08zm.852-1.616a1.956 1.956 0 00-.852 1.615h.081c0-.643.323-1.21.817-1.549l-.046-.066zm.062.024v-.002l-.078.022v.002l.078-.022zm-.016.044a1.87 1.87 0 011.066-.331v-.081c-.412 0-.795.128-1.111.346l.045.066zm1.066-.331c1.036 0 1.88.84 1.88 1.88h.081c0-1.084-.88-1.961-1.96-1.961v.08zm1.88 1.88a1.88 1.88 0 01-1.88 1.88v.081a1.96 1.96 0 001.961-1.961h-.08zm-1.88 1.88c-.378 0-.73-.113-1.026-.306l-.044.067c.308.202.676.32 1.07.32v-.08zm1.429-1.187c0 .15-.12.27-.27.27v.08c.195 0 .35-.155.35-.35h-.08zm-.27-.27c.15 0 .27.12.27.27h.08a.349.349 0 00-.35-.35v.08zm-.27.27c0-.15.12-.27.27-.27v-.08a.349.349 0 00-.35.35h.08zm.27.27a.27.27 0 01-.27-.27h-.08c0 .192.156.35.35.35v-.08zm-1.04-2.518a.082.082 0 01-.022-.054h-.08c0 .041.016.08.04.108l.061-.054zm.008.012a.055.055 0 01-.005-.006l-.068.042a.13.13 0 00.013.017l.06-.053zm-.069.04l.005.009.068-.044-.005-.008-.068.044zm.121-.023a.082.082 0 01-.058-.026l-.058.056c.03.03.07.05.116.05v-.08zm.083-.083a.084.084 0 01-.083.083v.08a.165.165 0 00.164-.163h-.081zm-.018-.05a.081.081 0 01.018.05h.08a.162.162 0 00-.035-.101l-.063.05zm.064-.051l-.008-.006-.05.063.008.006.05-.063zm-.08.034a.06.06 0 01.021.02l.067-.045a.14.14 0 00-.051-.046l-.038.071zm-.049-.015a.08.08 0 01.045.013l.044-.067a.16.16 0 00-.089-.027v.08zm-.082.082c0-.044.038-.082.082-.082v-.081a.165.165 0 00-.163.163h.081zm1.558 1.317a.084.084 0 01-.082.082v.081a.165.165 0 00.163-.163h-.081zm-.082-.082c.044 0 .082.038.082.082h.08a.165.165 0 00-.162-.163v.08zm-.083.082c0-.044.038-.082.083-.082v-.081a.165.165 0 00-.163.163h.08zm.083.082a.082.082 0 01-.083-.082h-.08c0 .088.07.163.163.163v-.08zm-1.45 1.7a.048.048 0 01-.047-.047h-.08c0 .07.058.127.127.127v-.08zm.046-.047a.048.048 0 01-.046.047v.08c.069 0 .127-.058.127-.127h-.08zm-.046-.046c.025 0 .046.022.046.046h.081a.129.129 0 00-.127-.127v.08zm-.047.046c0-.024.022-.046.047-.046v-.08a.129.129 0 00-.127.126h.08zm.476-.343a.16.16 0 01-.158.159v.08a.24.24 0 00.239-.239h-.08zm-.158-.159a.16.16 0 01.158.16h.081a.24.24 0 00-.24-.24v.08zm-.16.16a.16.16 0 01.16-.16v-.08a.24.24 0 00-.24.24h.08zm.16.158a.161.161 0 01-.16-.16l-.08.002c.004.13.107.239.24.239v-.081z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#A176F3",
                    d: "M40.578 77.884c0 .186-.021.367-.064.541a2.08 2.08 0 01-.484.906 1.92 1.92 0 01-.862.536 1.94 1.94 0 01-.542.073 1.952 1.952 0 01-1.696-.976 2.022 2.022 0 01-.262-1 2.163 2.163 0 01.25-1.01c.081-.152.18-.292.295-.419a1.88 1.88 0 01.85-.545c.166-.051.341-.077.526-.077.298 0 .569.046.813.139a1.738 1.738 0 011.032 1.019c.096.242.144.513.144.813zm-1.367.08a.821.821 0 00-.04-.256.662.662 0 00-.11-.222.547.547 0 00-.435-.218.598.598 0 00-.579.41.752.752 0 00-.043.255c0 .086.013.172.037.258a.77.77 0 00.111.234c.05.07.11.127.182.17a.585.585 0 00.711-.145.724.724 0 00.123-.225.805.805 0 00.043-.261z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#A3D946",
                    d: "M41.208 77.047a.047.047 0 00.065-.02c.049-.093.097-.188.145-.273.24-.421.6-.668 1.073-.753a3.913 3.913 0 011.007-.035.048.048 0 01.043.056c-.016.102-.025.195-.053.289-.061.23-.123.466-.204.69-.204.546-.611.844-1.172.964a.842.842 0 00-.088.022.046.046 0 00-.031.055c.026.105.056.208.08.314.005.023-.002.055-.016.065l-.006.003c-.23.125-.46.25-.7.368a.047.047 0 01-.065-.06l.222-.565a.047.047 0 00-.044-.064c-.173-.002-.341.001-.515 0a.047.047 0 01-.046-.057c.03-.15.062-.3.092-.455a.047.047 0 00-.052-.057c-.186.023-.374.045-.569.071a.048.048 0 01-.043-.078c.179-.21.356-.412.534-.619a.047.047 0 01.056-.012c.095.045.19.098.287.15z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "42.41",
                    cy: "76.881",
                    r: "0.31",
                    fill: "#fff",
                    stroke: "#A176F3",
                    strokeWidth: "0.104",
                    transform: "rotate(6.224 42.41 76.88)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    stroke: "#A176F3",
                    strokeWidth: "0.127",
                    d: "M41.363 76.722h0a9.79 9.79 0 00-.127.238l-.012.023-.022-.012a4.732 4.732 0 00-.254-.132.11.11 0 00-.13.028l-.189.217-.346.402a.111.111 0 00.1.182c.177-.024.35-.044.52-.065.009 0 .017-.002.026-.003l-.046.228-.042.206a.11.11 0 00.108.132h.491l-.133.341-.08.202a.11.11 0 00.152.14c.241-.12.472-.245.702-.37 0 0 0 0 0 0s0 0 0 0a.088.088 0 00.01-.004c.029-.019.04-.05.043-.067a.151.151 0 00.001-.066h0a5.456 5.456 0 00-.046-.183l-.03-.116a.744.744 0 01.064-.015h.002c.578-.125 1.005-.435 1.218-1.004h0c.08-.222.142-.452.201-.676l.005-.02c.023-.078.035-.157.046-.235l.009-.061a.112.112 0 00-.1-.129 3.978 3.978 0 00-1.024.035h0c-.49.089-.868.346-1.117.784zm1.921.28h0z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#A3D946",
                    stroke: "#A176F3",
                    strokeWidth: "0.127",
                    d: "M39.393 78.325a.725.725 0 01.666-.338l.19.04a.73.73 0 01.264 1.217 2.19 2.19 0 01-.076.079h.001a2.164 2.164 0 01-.596.414 2.17 2.17 0 01-2.173-.174 2.253 2.253 0 01-.849-1.153l-.002-.028c1.131.95 2.114.423 2.534-.018a.61.61 0 00.041-.039z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                            id: "filter0_d_1630_5670",
                            width: "117.671",
                            height: "161.919",
                            x: "0",
                            y: "0",
                            colorInterpolationFilters: "sRGB",
                            filterUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                    floodOpacity: "0",
                                    result: "BackgroundImageFix"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                    in: "SourceAlpha",
                                    result: "hardAlpha",
                                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                    dx: "1.351",
                                    dy: "1.351"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                    stdDeviation: "0.676"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                    in2: "hardAlpha",
                                    operator: "out"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                    in2: "BackgroundImageFix",
                                    result: "effect1_dropShadow_1630_5670"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                    in: "SourceGraphic",
                                    in2: "effect1_dropShadow_1630_5670",
                                    result: "shape"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                            id: "filter1_d_1630_5670",
                            width: "31.814",
                            height: "45.494",
                            x: "-0.001",
                            y: "55.834",
                            colorInterpolationFilters: "sRGB",
                            filterUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                    floodOpacity: "0",
                                    result: "BackgroundImageFix"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                    in: "SourceAlpha",
                                    result: "hardAlpha",
                                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                    dy: "0.636"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                    stdDeviation: "0.318"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                    in2: "hardAlpha",
                                    operator: "out"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                    in2: "BackgroundImageFix",
                                    result: "effect1_dropShadow_1630_5670"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                    in: "SourceGraphic",
                                    in2: "effect1_dropShadow_1630_5670",
                                    result: "shape"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                            id: "filter2_d_1630_5670",
                            width: "43.585",
                            height: "89.875",
                            x: "22.747",
                            y: "51.221",
                            colorInterpolationFilters: "sRGB",
                            filterUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                    floodOpacity: "0",
                                    result: "BackgroundImageFix"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                    in: "SourceAlpha",
                                    result: "hardAlpha",
                                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                    dy: "0.636"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                    stdDeviation: "0.318"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                    in2: "hardAlpha",
                                    operator: "out"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                    in2: "BackgroundImageFix",
                                    result: "effect1_dropShadow_1630_5670"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                    in: "SourceGraphic",
                                    in2: "effect1_dropShadow_1630_5670",
                                    result: "shape"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                            id: "filter3_d_1630_5670",
                            width: "54.885",
                            height: "50.08",
                            x: "50.294",
                            y: "34.074",
                            colorInterpolationFilters: "sRGB",
                            filterUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                    floodOpacity: "0",
                                    result: "BackgroundImageFix"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                    in: "SourceAlpha",
                                    result: "hardAlpha",
                                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                    dy: "0.636"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                    stdDeviation: "0.318"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                    in2: "hardAlpha",
                                    operator: "out"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                    in2: "BackgroundImageFix",
                                    result: "effect1_dropShadow_1630_5670"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                    in: "SourceGraphic",
                                    in2: "effect1_dropShadow_1630_5670",
                                    result: "shape"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                            id: "filter4_d_1630_5670",
                            width: "70.811",
                            height: "70.811",
                            x: "7.954",
                            y: "-2.703",
                            colorInterpolationFilters: "sRGB",
                            filterUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                    floodOpacity: "0",
                                    result: "BackgroundImageFix"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                    in: "SourceAlpha",
                                    result: "hardAlpha",
                                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                    stdDeviation: "1.351"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                                    in2: "hardAlpha",
                                    operator: "out"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                    in2: "BackgroundImageFix",
                                    result: "effect1_dropShadow_1630_5670"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                    in: "SourceGraphic",
                                    in2: "effect1_dropShadow_1630_5670",
                                    result: "shape"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                            id: "paint0_linear_1630_5670",
                            x1: "15.045",
                            x2: "15.045",
                            y1: "61.543",
                            y2: "89.084",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    stopColor: "#EFF2F3"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "#fff"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                            id: "paint1_linear_1630_5670",
                            x1: "44.539",
                            x2: "44.539",
                            y1: "51.281",
                            y2: "109.874",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    stopColor: "#E3E9EB"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "0.567",
                                    stopColor: "#fff"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                            id: "paint2_linear_1630_5670",
                            x1: "57.444",
                            x2: "53.759",
                            y1: "145.838",
                            y2: "151.493",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    stopColor: "#504A44"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "#504A44",
                                    stopOpacity: "0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                            id: "paint3_linear_1630_5670",
                            x1: "31.558",
                            x2: "35.244",
                            y1: "145.679",
                            y2: "151.334",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    stopColor: "#504A44"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "#504A44",
                                    stopOpacity: "0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                            id: "paint4_linear_1630_5670",
                            x1: "91.413",
                            x2: "67.713",
                            y1: "49.382",
                            y2: "63.41",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    stopColor: "#EFF2F3"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "#fff"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                            id: "paint5_radial_1630_5670",
                            cx: "0",
                            cy: "0",
                            r: "1",
                            gradientTransform: "rotate(-8.738 482.733 -348.05) scale(47.9461)",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "0.381",
                                    stopColor: "#BFCCD1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "0.758",
                                    stopColor: "#fff"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                            id: "paint6_linear_1630_5670",
                            x1: "16.271",
                            x2: "61.992",
                            y1: "37.009",
                            y2: "15.214",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    stopColor: "#FFF668"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "0.519",
                                    stopColor: "#FF9C4C"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "#800"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                            id: "paint7_radial_1630_5670",
                            cx: "0",
                            cy: "0",
                            r: "1",
                            gradientTransform: "rotate(.305 -7083.77 5371.927) scale(60.6657)",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "0.181",
                                    stopColor: "#fff"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "0.939",
                                    stopColor: "#800"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var PanIcon = (Icon);

;// CONCATENATED MODULE: ./packages/uikit/src/components/Spinner/PancakeIcon.tsx





var PancakeIcon_Icon = function Icon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 128 128"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "51",
            height: "51",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                    id: "mask0_1434_5418",
                    style: {
                        maskType: "alpha"
                    },
                    width: "51",
                    height: "51",
                    x: "0",
                    y: "0",
                    maskUnits: "userSpaceOnUse",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#C4C4C4",
                        d: "M0 0H50.075V50.075H0z"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    mask: "url(#mask0_1434_5418)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "24.372",
                            cy: "24.997",
                            r: "16.234",
                            fill: "url(#paint0_linear_1434_5418)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "url(#paint1_linear_1434_5418)",
                            d: "M36.618 28.126c.926 2.69-2.484 6.303-7.617 8.071-5.134 1.768-10.046 1.022-10.972-1.667-.927-2.69 2.484-6.303 7.617-8.071 5.133-1.768 10.046-1.022 10.972 1.667z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#1F2337",
                            d: "M28.9 33.81c-2.424 1.768-6.618 2.227-9.368 1.026-1.374-.602-2.128-1.504-2.235-2.477l.15 1.37c.107.973.86 1.877 2.235 2.477 2.75 1.202 6.944.742 9.368-1.027 1.211-.885 1.752-1.929 1.646-2.902l-.15-1.37c.106.972-.434 2.017-1.646 2.902z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#4048FF",
                            d: "M28.311 28.429c1.374.601 2.129 1.504 2.235 2.477.107.973-.433 2.018-1.645 2.902-2.424 1.769-6.618 2.228-9.368 1.027-1.374-.602-2.129-1.504-2.235-2.477-.107-.973.433-2.019 1.646-2.902 2.425-1.77 6.617-2.23 9.367-1.027z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#B5E4FF",
                            d: "M28.048 25.677l-4.188-2.849a.956.956 0 00-.143-.078c-.447-.195-1.127-.12-1.52.167a.841.841 0 00-.123.107l-3.47 3.688c-.582.62-.834 1.29-.764 1.927l.396 3.616c.092.836.739 1.611 1.919 2.127 2.361 1.033 5.961.639 8.043-.881 1.04-.76 1.504-1.657 1.412-2.492l-.396-3.616c-.07-.636-.462-1.238-1.166-1.716z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#B5E4FF",
                            d: "M26.365 16.778c-2.082 1.52-5.682 1.915-8.043.882-1.18-.517-1.827-1.292-1.919-2.127l.397 3.615c.07.636.461 1.238 1.164 1.716l4.188 2.849a.962.962 0 00.143.078c.447.195 1.127.12 1.52-.167a.842.842 0 00.123-.107l3.472-3.688c.582-.62.835-1.29.765-1.928l-.396-3.615c.09.836-.374 1.733-1.414 2.492z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#FFC142",
                            d: "M27.849 17.429l.055.504c.063.573-.178 1.165-.694 1.713l-3.472 3.687a.545.545 0 01-.085.073c-.15.11-.373.188-.61.213a1.3 1.3 0 01-.64-.076.599.599 0 01-.1-.053l-4.186-2.847c-.623-.424-.986-.95-1.049-1.522l-.055-.505c.087.797.704 1.535 1.827 2.026 2.249.984 5.678.608 7.662-.84.992-.722 1.434-1.577 1.347-2.373z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#FFA318",
                            d: "M27.848 17.427c.088.797-.354 1.651-1.345 2.374-1.982 1.448-5.412 1.824-7.662.84-1.123-.491-1.74-1.23-1.827-2.026-.044-.403.048-.821.278-1.23.223-.397.579-.786 1.067-1.144 1.982-1.447 5.412-1.823 7.662-.84.555.244.985.547 1.29.887.312.348.493.736.537 1.14z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#1F2337",
                            d: "M26.92 15.717c-2.425 1.769-6.619 2.228-9.369 1.027-1.374-.602-2.127-1.504-2.234-2.479l.15 1.37c.107.974.86 1.877 2.236 2.478 2.75 1.201 6.944.741 9.367-1.027 1.212-.885 1.753-1.93 1.646-2.903l-.15-1.37c.106.975-.434 2.019-1.647 2.904z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#4048FF",
                            d: "M26.328 10.337c1.375.601 2.129 1.504 2.236 2.477.106.973-.433 2.018-1.646 2.902-2.424 1.769-6.618 2.229-9.368 1.027-1.374-.6-2.127-1.503-2.234-2.477-.107-.975.433-2.019 1.646-2.902 2.424-1.77 6.617-2.229 9.366-1.027z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#B0E1FF",
                            d: "M28.198 33.5c1.04-.76 1.504-1.657 1.412-2.493-.092-.836-.739-1.611-1.919-2.127-2.361-1.033-5.961-.639-8.043.881-1.04.76-1.504 1.657-1.412 2.493.092.836.739 1.61 1.919 2.127 2.36 1.033 5.961.638 8.043-.881z",
                            opacity: "0.5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#B0E1FF",
                            d: "M28 33.414c.993-.724 1.435-1.58 1.347-2.378-.087-.797-.704-1.537-1.83-2.029-2.251-.985-5.687-.608-7.672.84-.992.725-1.435 1.581-1.347 2.379.087.797.704 1.537 1.83 2.03 2.252.984 5.686.607 7.672-.842z",
                            opacity: "0.63"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#FFA318",
                            d: "M27.289 26.924a3.624 3.624 0 00-.142-.06l-3.625-1.462-.558.061-3.222 2.213c-.044.03-.086.06-.126.09-.993.724-1.435 1.58-1.348 2.377.088.798.705 1.537 1.83 2.03 2.252.984 5.688.608 7.673-.841.992-.725 1.434-1.58 1.347-2.378-.086-.798-.703-1.538-1.829-2.03z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#FFC142",
                            d: "M27.772 31.33c-1.985 1.449-5.42 1.825-7.672.84-1.126-.492-1.743-1.231-1.83-2.029l.228 2.085c.087.798.704 1.537 1.83 2.03 2.252.984 5.688.608 7.672-.841.993-.725 1.435-1.58 1.348-2.378l-.229-2.085c.087.799-.355 1.653-1.347 2.378zM23.568 25.739c.075-.055.108-.12.101-.179-.006-.06-.052-.116-.137-.153a.654.654 0 00-.569.056c-.084.062-.117.126-.11.186.006.061.053.116.137.153.17.074.43.046.578-.063z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#FFC142",
                            d: "M23.418 23.266l-.816.09.251 2.294.817-.09-.252-2.294z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                            id: "paint0_linear_1434_5418",
                            x1: "24.372",
                            x2: "24.372",
                            y1: "8.763",
                            y2: "51.338",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    stopColor: "#00CC9E"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "#4048FF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                            id: "paint1_linear_1434_5418",
                            x1: "33.983",
                            x2: "23.744",
                            y1: "39.881",
                            y2: "25.68",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    stopColor: "#1F2337"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "#1F2337",
                                    stopOpacity: "0"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var PancakeIcon = (PancakeIcon_Icon);

;// CONCATENATED MODULE: ./packages/uikit/src/components/Spinner/Spinner.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	0% {\n		transform: translatey(0px);\n	}\n	50% {\n		transform: translatey(20px);\n	}\n	100% {\n		transform: translatey(0px);\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 70%;\n  animation: ",
        " 3s linear infinite;\n  transform: translate3d(50%, 50%, 50%);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 6s ease-in-out infinite;\n  transform: translate3d(0, 0, 0);\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var rotate = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var Spinner_float = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35bd296b-0"
}).withConfig({
    componentId: "sc-39fd393e-0"
})(_templateObject2());
var RotatingPancakeIcon = (0,styled_components_browser_esm/* default */.ZP)(PancakeIcon).withConfig({
    componentId: "sc-35bd296b-1"
}).withConfig({
    componentId: "sc-39fd393e-1"
})(_templateObject3(), Spinner_float);
var FloatingPanIcon = (0,styled_components_browser_esm/* default */.ZP)(PanIcon).withConfig({
    componentId: "sc-35bd296b-2"
}).withConfig({
    componentId: "sc-39fd393e-2"
})(_templateObject4(), Spinner_float);
var Spinner = function Spinner(param) {
    var _size = param.size, size = _size === void 0 ? 128 : _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RotatingPancakeIcon, {
                width: "".concat(size, "px")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingPanIcon, {
                width: "".concat(size, "px")
            })
        ]
    });
};
/* harmony default export */ var Spinner_Spinner = (Spinner);


/***/ })

}]);